import styled from "styled-components";

export const ImgResponsive = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;
